import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PartnerMutationKeys } from '../../../../manage-player/keys'
import {
	UpdatePartnerRequest,
	UpdatePartnerResponse,
} from '../../../../manage-player/type'
import { updatePartner } from '../../../../manage-player/api/services'

interface UseMutationUpdatePartnerProps {
	id: string
	payload: UpdatePartnerRequest
}

export default function useMutationUpdatePartner(
	props?: UseBaseMutationOptions<
		UpdatePartnerResponse,
		UseMutationUpdatePartnerProps
	>,
) {
	return useMutation({
		mutationKey: [PartnerMutationKeys.UpdatePartner],
		mutationFn: (params) => updatePartner(params.id, params.payload),
		...props,
	})
}
